const options = {
  5: "bg-yellow-300/5",
  10: "bg-yellow-300/10",
  25: "bg-yellow-300/25",
  50: "bg-yellow-300/50",
  75: "bg-yellow-300/75",
  90: "bg-yellow-300/90",
  100: "bg-yellow-300",
};

const from = {
  5: "from-yellow-300/5",
  10: "from-yellow-300/10",
  25: "from-yellow-300/25",
  50: "from-yellow-300/50",
  75: "from-yellow-300/75",
  90: "from-yellow-300/90",
  100: "from-yellow-300",
};

export default function getBackgroundYellow300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
